import { connect } from 'react-redux';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';

import Nothing from 'app/components/Children/Nothing';
import NotConnected from 'app/components/Children/NotConnected';

import makeNothing from './selectNothing';


// type Props = {
//   id: number,
//   date: string,
// };

export default compose(
  connect(
    () => {
      const nothing = makeNothing();
      return (state, props) => ({
        ...nothing(state, props),
      });
    }
  ),

  branch(
    props => props.noData,
    renderComponent(Nothing),
    renderComponent(NotConnected)
  )
)();
